import { styled } from '@mui/material';

import { extractTextMarking, StageWithVideo } from '@mewa/ui';

import { StrapiImage } from '../../templates/dynamic-content-page/content-components/image';
import { gatsbyVideoDataFromStrapiVideo } from '../../templates/dynamic-content-page/content-components/video/responsive-video';
import { ResponsiveVideoData } from '../../templates/dynamic-content-page/content-components/video/types';

export type StageVideoProps = {
  headline: string;
  subline: string;
  video: ResponsiveVideoData;
};

export const StageVideo = ({ data }: { data: StageVideoProps }) => {
  const markedHeadline = extractTextMarking(data.headline);

  const video = {
    desktopSources: gatsbyVideoDataFromStrapiVideo(data.video.videoDesktop),
    mobileSources: gatsbyVideoDataFromStrapiVideo(data.video.videoMobile),
    posterImage: data.video.posterImage ? (
      <StrapiImage responsiveImage={data.video.posterImage} />
    ) : null,
  };

  return (
    <Wrapper>
      <StageWithVideo
        title={markedHeadline}
        subtitle={data.subline}
        video={video}
      />
    </Wrapper>
  );
};

const Wrapper = styled('div')({
  marginBottom: '50px',
});
